module.exports = __webpack_public_path__ + "static/img/10.d43f93dd.jpg";